const createAccessibeScript = () => `
(function () {
  var s = document.createElement("script"),
    e = !document.body ? document.querySelector("head") : document.body;
  s.src = "https://acsbapp.com/apps/app/dist/js/app.js";
  s.async = true;
  s.onload = function () {
    acsbJS.init({
      statementLink: "",
      footerHtml: "",
      hideMobile: false,
      hideTrigger: false,
      language: "en",
      position: "right",
      leadColor: "#323232",
      triggerColor: "#323232",
      triggerRadius: "50%",
      triggerPositionX: "right",
      triggerPositionY: "bottom",
      triggerIcon: "wheels",
      triggerSize: "medium",
      triggerOffsetX: 20,
      triggerOffsetY: 20,
      mobile: {
        triggerSize: "small",
        triggerPositionX: "right",
        triggerPositionY: "bottom",
        triggerOffsetX: 10,
        triggerOffsetY: 10,
        triggerRadius: "0",
      },
    });
  };
  e.appendChild(s);
})();

`;

export default createAccessibeScript;
